import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { IChangedCustomElement } from '../html-elements';

@Component({
  selector: 'app-toggle-html-element',
  templateUrl: './toggle-html-element.component.html',
  styleUrls: ['./toggle-html-element.component.scss']
})
export class ToggleHtmlElementComponent {

  myGroup: FormGroup = new FormGroup({
    customElement: new FormControl(),
  });

  @Input() idx;
  @Input() name;
  @Input() value;

  @Output() changed:EventEmitter<IChangedCustomElement> = new EventEmitter<IChangedCustomElement>();

  ngOnInit(): void {
    this.myGroup.patchValue({customElement:this.value === "true"});
  }

  OnChanged($event: MatSlideToggleChange) {
    this.changed.emit({
      idx: this.idx,
      value: $event.checked
    })
  }

}
